import PropTypes from 'prop-types';
import StoreInfoPropType from './storeInfo.proptype';

export default function DeliveryOptionStoreInformation(props) {
  const storeInformation = `${props.store.name}, ${props.store.postcode}`;
  
  return (
    <span>
      {storeInformation}
    </span>
  );
}

DeliveryOptionStoreInformation.propTypes = {
  store: PropTypes.shape(StoreInfoPropType).isRequired,
};
